module.exports = new __parcel__URL__("93201_h.78e0fb5d.jpg").toString();